<template>
  <div class="g-box">
    <!--ぱんくず-->
    <breadcrumb :pathList="pathList">
    </breadcrumb>
    <!--/ぱんくず-->
    <main class="g-content">
      <h1 class="g-h-1 g-rainbow">About this site</h1>
      <section class="g-unit-xl">
        <p>The Minpaku Kaleidoscope "Info-Forum Museum Object Database" is an integrated search engine which enables users to look for information across all the object databases created through the Info-Forum Museum project. It uses a common index to facilitate cross searching as well as associative searching, and allows users to browse information from other related databases, such as Minpaku Artifact Catalog.</p>
      </section>
      <section class="g-unit-xl">
        <p><b>Databases available in this site</b></p>
        <ul class="g-list g-list-disc">
          <li><a class="g-link" href="https://ifm.minpaku.ac.jp/taiwan/en/" target="_blank">Material Culture in Taiwan and Neighboring Islands<i class="g-i g-i-blank" aria-hidden="true"></i></a></li>
          <li><a class="g-link" href="https://ifm.minpaku.ac.jp/georgebrown/" target="_blank">The George Brown Collection<i class="g-i g-i-blank" aria-hidden="true"></i></a></li>
          <li><a class="g-link" href="https://ifm.minpaku.ac.jp/japaneseCulture/" target="_blank">“Culture of Japan” Exhibition Database<i class="g-i g-i-blank" aria-hidden="true"></i></a></li>
          <li><a class="g-link" href="https://ifm.minpaku.ac.jp/canada/" target="_blank">The Cultural Resources of Indigenous Peoples in Northern North America<i class="g-i g-i-blank" aria-hidden="true"></i></a></li>
          <li><a class="g-link" href="https://ifm.minpaku.ac.jp/mepc/" target="_blank">Database for Popular Culture Collections from the Middle East<i class="g-i g-i-blank" aria-hidden="true"></i></a></li>
        </ul>
      </section>
    </main>
  </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb.vue'

export default {
  components: {
    breadcrumb
  },
  computed: {
    // パン屑リスト
    pathList: function() {
      return [
        { path: '/', text: 'Site.home' },
        { path: '/about', text: 'Site.about_this_website' },
      ]
    },
  }
}

</script>
